import React from 'react'
import './BeforeFooter.css';
import {Grid} from '@mui/material';
import {BsGlobe,BsCurrencyDollar,BsTwitter} from 'react-icons/bs';
import {FaFacebookF} from 'react-icons/fa'
import {ImInstagram} from 'react-icons/im';
const BeforeFooter = () => {

    return (
    <div className='BeforeFooterMain'>
        <Grid container>
            <Grid item md={3}>
            <p className='beforeHeaderTitles'>Support</p>
                <p>Help Center</p>
                <p>AirCover</p>
                <p>Safety information</p>
                <p>Supporting people with disabilities</p>
                <p>Cancellation options</p>
                <p>Our COVID-19 Response</p>
                <p>Report a neighbourhood concern</p>
            </Grid>
            <Grid item md={3}>
            <p className='beforeHeaderTitles'>Community</p>
                <p>Airbnb.org:disaster relief housing</p>
                <p>Support Afghan refugees</p>
                <p>Combating discrimination</p>                
            </Grid>
            <Grid item md={3}>
            <p className='beforeHeaderTitles'>Hosting</p>
                <p>Try Hosting</p>
                <p>AirCover for Hosts</p>
                <p>Explore hosting resources</p>
                <p>Visit our community forum</p>
                <p>How to host responsibly</p>
            </Grid>
            <Grid item md={3}>
            <p className='beforeHeaderTitles'>Airbnb</p>
                <p>Newsroom</p>
                <p>Learn about new features</p>
                <p>Letter from our founders</p>
                <p>Careers</p>
                <p>Investors</p>
                <p>Gift cards</p>

            </Grid>
        </Grid>
        <hr/>
        <div className='beforeFooterLastMain'>
            <span>&copy; 2022 Airbnb,Inc &bull; Privacy &bull; Terms &bull; sitemap</span>
            <span className='detailsSpan'><BsGlobe className='globe' /> English (US) <BsCurrencyDollar  className='dollar'/> USD <FaFacebookF  className='fb'/> <BsTwitter  className='twitter'/> <ImInstagram className='insta'/> </span>
        </div>
    </div>
  )
}

export default BeforeFooter